/* eslint-disable react-refresh/only-export-components -- co-located helpers/constants */
import type { ChipProps } from '@mui/material';
import { Chip } from '@mui/material';
import type { OrderStatus } from '@cnapse/shared/schemas.js';

/** Human-readable labels for order lifecycle states. */
export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  draft: 'Draft',
  confirmed: 'Confirmed',
  shipped: 'Shipped',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export const ORDER_STATUS_OPTIONS: OrderStatus[] = [
  'draft',
  'confirmed',
  'shipped',
  'completed',
  'cancelled',
];

/**
 * MUI semantic chip colors for order lifecycle.
 * Follows app-wide pattern: neutral → info (in progress) → success (done) / error (terminal).
 */
export type OrderStatusChipColor = Exclude<
  ChipProps['color'],
  'primary' | 'secondary' | undefined
>;

export const ORDER_STATUS_CHIP_COLORS: Record<OrderStatus, OrderStatusChipColor> = {
  draft: 'default',
  confirmed: 'info',
  shipped: 'info',
  completed: 'success',
  cancelled: 'error',
};

interface OrderStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: OrderStatus;
}

/** Standard order lifecycle chip — matches list/detail pages and MUI semantic palette. */
export function OrderStatusChip({ status, size = 'small', ...props }: OrderStatusChipProps) {
  return (
    <Chip
      {...props}
      size={size}
      label={ORDER_STATUS_LABELS[status]}
      color={ORDER_STATUS_CHIP_COLORS[status]}
    />
  );
}
